import { GET_1BILL_PAYMENT_REPORT } from "../../../Types";

const OneBillPaymentReportReducer = (state = [], action) => {
  switch (action.type) {
    case GET_1BILL_PAYMENT_REPORT:
      return action.payload;
    default:
      return state;
  }
};
export default OneBillPaymentReportReducer;
